import { Paper } from "@material-ui/core";
import { useEmblaCarousel } from "embla-carousel/react";
import React, { useCallback, useEffect, useState } from "react";
import "./EmblaCarousel.css";

interface Props {
  slides: Array<string>;
}

interface ThumbProps {
  selected: boolean;
  imgSrc: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const Thumb = ({ selected, onClick, imgSrc }: ThumbProps) => (
  <div
    className={`embla__slide embla__slide--thumb ${
      selected ? "is-selected" : ""
    }`}>
    <button
      onClick={onClick}
      className="embla__slide__inner embla__slide__inner--thumb"
      type="button">
      <img className="embla__slide__thumbnail" src={imgSrc} alt="" />
    </button>
  </div>
);

export const EmblaCarousel = ({ slides }: Props) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [mainViewportRef, embla] = useEmblaCarousel();
  const [thumbViewportRef, emblaThumbs] = useEmblaCarousel({
    containScroll: "keepSnaps",
    selectedClass: "",
  });

  const onThumbClick = useCallback(
    (index) => {
      if (!embla || !emblaThumbs) return;
      if (emblaThumbs.clickAllowed()) embla.scrollTo(index);
    },
    [embla, emblaThumbs]
  );

  const onSelect = useCallback(() => {
    if (!embla || !emblaThumbs) return;
    setSelectedIndex(embla.selectedScrollSnap());
    emblaThumbs.scrollTo(embla.selectedScrollSnap());
  }, [embla, emblaThumbs, setSelectedIndex]);

  useEffect(() => {
    if (!embla) return;
    onSelect();
    embla.on("select", onSelect);
  }, [embla, onSelect]);

  return (
    <Paper className="embla-wrapper">
      <div className="embla">
        <div className="embla__viewport" ref={mainViewportRef}>
          <div className="embla__container">
            {slides.map((slide, idx) => (
              <div className="embla__slide" key={idx}>
                <div className="embla__slide__inner">
                  <img className="embla__slide__img" src={slide} alt="" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="embla embla--thumb">
        <div className="embla__viewport" ref={thumbViewportRef}>
          <div className="embla__container embla__container--thumb">
            {slides.map((slide, index) => (
              <Thumb
                onClick={() => onThumbClick(index)}
                selected={index === selectedIndex}
                imgSrc={slide}
                key={index}
              />
            ))}
          </div>
        </div>
      </div>
    </Paper>
  );
};
